// src/pages/Workers/Attendance/ExportMonthlySummaryExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportMonthlySummaryExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Monthly Summary");
  const t = i18n.t.bind(i18n);
  worksheet.columns = [
    { header: t("monthlySummary.columns.id"), key: "id", width: 10 },
    { header: t("monthlySummary.columns.date"), key: "date", width: 20 },
    { header: t("monthlySummary.columns.checkIn"), key: "checkIn", width: 15 },
    { header: t("monthlySummary.columns.checkOut"), key: "checkOut", width: 15 },
    { header: t("monthlySummary.columns.location"), key: "location", width: 25 },
    { header: t("monthlySummary.columns.issues"), key: "issuesCount", width: 12 },
    { header: t("monthlySummary.columns.status"), key: "status", width: 15 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Monthly_Summary_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportMonthlySummaryExcel;
